import { View, RadioGroup, Label, YStack } from 'tamagui'
import { QuestionWrapper } from './QuestionWrapper'
import { useFormContext, Controller } from 'react-hook-form'
import { useCallback } from 'react'
import { IExamQuestionOption } from '@dtos/Activity'

interface IMultipleChoiceQuestionProps {
  options: IExamQuestionOption[]
  questionId: string
  previousAnswer?: {
    selectedOption: string
    correct: boolean
    score: number
  }
  mode: 'edit' | 'readonly' | 'retry'
}

export function MultipleChoiceQuestion({
  options,
  questionId,
  previousAnswer,
  mode,
}: IMultipleChoiceQuestionProps) {
  const { control } = useFormContext()

  const getColor = useCallback(
    (value: string, ref: string, isTransparent = false) => {
      if (value === ref) {
        if (!previousAnswer) return '$accent'
        if (previousAnswer?.correct) return '$success-300'
        return '$danger-300'
      }

      return isTransparent ? 'transparent' : '$control-inactive'
    },
    [previousAnswer],
  )

  return (
    <View>
      <Controller
        name={questionId}
        control={control}
        defaultValue={previousAnswer?.selectedOption || ''}
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            name={`multiple-choice-${questionId}`}
            onValueChange={mode === 'edit' ? onChange : undefined}
            value={value}
            disabled={mode === 'readonly' || mode === 'retry'}
          >
            <YStack gap="$spacing-inset-nano">
              {options.map((option) => (
                <QuestionWrapper
                  key={option.id}
                  color={getColor(value, option.id)}
                >
                  {/* flex + minWidth 0: sem isso a linha herda flexShrink 0 do
                      RN e cresce até o max-content da alternativa, cortando o
                      texto na direita em vez de quebrar linha. */}
                  <View
                    flexDirection="row"
                    alignItems="center"
                    flex={1}
                    minWidth={0}
                  >
                    <RadioGroup.Item
                      value={option.id}
                      id={`${option.id}-${questionId}`}
                      borderColor="$border-default"
                      backgroundColor={getColor(value, option.id, true)}
                      size={'$spacing-lg'}
                    >
                      <RadioGroup.Indicator
                        borderWidth={1}
                        w={8}
                        h={8}
                        borderColor={getColor(value, option.id)}
                        backgroundColor={
                          value === option.id
                            ? '$bg-surface-raised'
                            : 'transparent'
                        }
                      />
                    </RadioGroup.Item>
                    <Label
                      color="$text-primary"
                      fontFamily="$mulishRegular"
                      size={'$font-size-xxs'}
                      htmlFor={`${option.id}-${questionId}`}
                      p="$spacing-inset-xs"
                      flex={1}
                      minWidth={0}
                      flexShrink={1}
                    >
                      {option.title}
                    </Label>
                  </View>
                </QuestionWrapper>
              ))}
            </YStack>
          </RadioGroup>
        )}
      />
    </View>
  )
}
